import * as masterDataAction from './master-data-action'

export {
  masterDataAction,
}



// WEBPACK FOOTER //
// ./src/actions/master-data/index.js